import { TFunction } from 'i18next';
import { ListRowProps } from '../../../../../tools';
import { getSafeString } from './utils';
import { ApplicationResponse, Consultation } from '../../../../../types';
import { StandardDateFormats, useFormatLocaleDate } from '../../../../../config';

export const useApplicationDetailItems = (
  t: TFunction,
  isTQ = false,
  application?: ApplicationResponse,
  consultation?: Consultation
): ListRowProps[] => {
  const formatLocaleDate = useFormatLocaleDate();
  const renderFormattedDate = (value: Date | undefined) =>
    value ? formatLocaleDate(value) : '-';

  return !consultation
    ? []
    : getDetails(t, isTQ, consultation, renderFormattedDate, formatLocaleDate, application);
};

const getDetail = (label: string, value: string): ListRowProps => {
  return { label, value: value };
};

const getDetails = (
  t: TFunction,
  isTQ: boolean,
  consultation: Consultation,
  renderFormattedDate: (value: Date | undefined) => string,
  formatLocaleDate: (
    dateValue: Date | string | undefined,
    format?: StandardDateFormats
  ) => string,
  application?: ApplicationResponse
) => {
  return [
    getDetail(
      t('application_reference', 'Application reference'),
      isTQ
        ? getSafeString(consultation?.reference)
        : getSafeString(application?.planningPortalReference)
    ),
    getDetail(
      t('application_received', 'Application received'),
      renderFormattedDate(application?.dateReceived)
    ),
    getDetail(
      t('application_decided', 'Application decided'),
      application?.decisionDate ? formatLocaleDate(application?.decisionDate) : '-'
    ),
    getDetail(t('address', 'Address'), consultation?.address ?? ''),
    getDetail(
      t('status', 'Status'),
      getSafeString(application?.applicationStatus?.toString() ?? '')
    ),
    getDetail(t('decision', 'Decision'), getSafeString(application?.applicationDecisionType)),
    getDetail(
      isTQ ? t('municipality', 'Municipality') : t('authority', 'Authority'),
      consultation?.authority
    ),
    getDetail(
      t('district_electoral_area', 'District Electoral Area (DEA)'),
      getSafeString(application?.districtElectoralArea)
    ),
    getDetail(
      t('applicant_name', 'Applicant name'),
      getSafeString(application?.applicantsName)
    ),
    getDetail(
      consultation?.pacReference ? t('pac_reference', 'PAC Reference') : '',
      consultation?.pacReference ? getSafeString(consultation?.pacReference) : ''
    ),
  ];
};
